import type { NskResponse } from "~/models/Api";
import { postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/vendors/deals/:deal_id/deal_completion_report_completes"
};

export const create = async (dealId: number): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)));
